module.exports = __webpack_public_path__ + "static/img/5f3253558fb363aff223703701921b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_03.png
// module id = 2Wyw
// module chunks = 1